import {cn} from '@/utils/common_functions';
import {PropsWithChildren, useEffect, useRef} from 'react';
interface ModalProps extends PropsWithChildren {
  open: boolean;
  onClose?: () => void;
  className?: string;
}
export const Modal: React.FC<ModalProps> = props => {
  const {children, open, onClose, className} = props;
  const dialogRef = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (open) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [open]);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDialogElement>) => {
    // Close modal when clicking on the backdrop (the dialog element itself)
    if (e.target === dialogRef.current) {
      onClose?.();
    }
  };

  return (
    <dialog 
      style={{display: open ? undefined : 'none'}} 
      className={cn('bg-white max-w-[calc(100%-1.5rem)] w-full p-4 backdrop:bg-black/25', className)} 
      ref={dialogRef} 
      // onClose={onClose}
      onClick={handleBackdropClick}>
      {children}
    </dialog>
  );
};
